import ERPSBaseLink from "../components/custom/inputs/ERPSBaseLink";
import { t } from "i18next";
import { isBigFI, convertDateIntoERPSDateFormat, formatAmount } from "../utils/helper";
import { isPortalTypeAndRoles } from "../utils/bpportal-common-utils";
import { FI, RoleType, transactionStatusMap, TRACE_QUEUE_FI_ROLES, TRACE_QUEUE_BILLER_ROLES, TraceQueueRowStatus } from "./sharedConstants";

const TRACE_QUEUE_ROW_STATUSES = [TraceQueueRowStatus.FI_TO_RESPONSE, TraceQueueRowStatus.MERCHANT_TO_RESPONSE];

const getTraceQueueStatusKey = (roleId, rowStatus) => {
    if (!TRACE_QUEUE_ROW_STATUSES.includes(rowStatus)) return null;
    if (TRACE_QUEUE_FI_ROLES.includes(Number(roleId))) return `erps.tracequeue.status.role12.${rowStatus}`;
    if (TRACE_QUEUE_BILLER_ROLES.includes(Number(roleId))) return `erps.tracequeue.status.role34.${rowStatus}`;
    return `erps.tracequeue.status.other.${rowStatus}`;
};

export const transactionSearchHeading = (pageType, fiMap, idLink, fiNumber, user) => {
    const roleId = user?.role?.role_id;
    const isReturnsPortalLive = !user || (user.commonConfig?.IS_RETURNS_PORTAL_LIVE === "Y");  // 'user' is passed only from ReviewTransactions

    const getLinkState = (params) => {
      return (pageType === "TH") ? { id: params.row?.id, isReadonly: true } : { id: params.row?.id };
    };

    const columns = [
      { field: "id",
        headerName: t("erps.common.label.number.short"),
        width: 50,
        sortable: false,
        renderCell: (params) => (
          <ERPSBaseLink className="link__blue"
            to={ { pathname: idLink, state: getLinkState(params) }}
            label={ "" + params.row?.seqNo } />
          ),
      },
      { field: "transaction_amount",
        headerName: t("erps.common.label.paymentAmount"),
        width: 160,
        sortable: false,
        renderCell: (params) => { if (params.value)  return formatAmount(params.value); },
      },
      { field: "effective_date",
        headerName: t("erps.common.label.effectiveDate"),
        width: 110,
        sortable: false,
        renderCell: (params) => convertDateIntoERPSDateFormat(params.value),
      },
      { field: "verification_number",
        headerName: t("erps.common.label.confirmationNumber.short"),
        width: 184,
        sortable: false,
      },
      { field: "fi_biller_id",
        headerName: t("erps.common.label.billerID"),
        width: 140,
        sortable: false,
      },
      { field: "biller_customer_number",
        headerName: t("erps.common.label.customerAccountNumber.short"),
        width: 200,
        sortable: false,
      },
      (fiMap ?
        { field: "fi_number",
          headerName: t("erps.common.label.fi"),
          width: 230,
          sortable: false,
          renderCell: (params) => fiMap?.get(params.value) || params.value,
        }
      : { field: "fi_customer_name",
          headerName: t("erps.common.label.customerName"),
          width: 230,
          sortable: false,
        }
      )
    ];

    if (isReturnsPortalLive && "TQ" != pageType) {
      columns.push(
        { field: "transaction_status",
          headerName: t("erps.common.label.status"),
          width: 150,
          sortable: false,
          renderCell: (params) => t(transactionStatusMap.get(params.value), params.value),
        }
      );
    }

    if (fiNumber && roleId && isShowBankCard(roleId, fiNumber)) {
      columns.push(
        { field: "fi_customer_number_str",
          headerName: t("erps.transactionEnquiry.componentToPrint.customerDetails.label.bankCardNumber"),
          width: 180,
          sortable: false
        }
      );
    }

    if (pageType === "TQ" && user) {
      columns.push(
        { field: "transaction_status",
          headerName: t("erps.common.label.status"),
          width: 200,
          sortable: false,
          renderCell: (params) => {
            const key = getTraceQueueStatusKey(roleId, params.value);
            return key ? t(key) : params.value;
          },
        }
      );
    }

    return columns;
};

export const isShowBankCard = (roleId, fiNumber) => {    // When to show Bank Card
  // show for  1) Admin Roles,  2) FI roles for CIBC,  3) small FIs for FI roles in CANACT Portal   (FSCM-8421)
  return /*1)*/ roleId > 4
      || /*2)*/ (fiNumber == FI.CIBC && roleId <= 2)
      || /*3)*/ (!isBigFI(fiNumber) && isPortalTypeAndRoles("billpay", roleId, RoleType.WP_FI_ADMIN, RoleType.WP_FI_USER));
};

export const isShowSubscribingEntity = (roleType, fiNumber) => {
    return (roleType === RoleType.ERPADMIN.type || roleType === RoleType.BILLADMIN.type) && fiNumber == FI.TFX;
};
